/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Driver_Remittance_Payment_Not_HeldInputs */

const vi_error_driver_remittance_payment_not_held = /** @type {(inputs: Error_Driver_Remittance_Payment_Not_HeldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Có đơn vừa được người khác nhận tiền. Tải lại danh sách rồi thử lại.`)
};

/**

* @param {Error_Driver_Remittance_Payment_Not_HeldInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_driver_remittance_payment_not_held = /** @type {((inputs?: Error_Driver_Remittance_Payment_Not_HeldInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Driver_Remittance_Payment_Not_HeldInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_driver_remittance_payment_not_held(inputs)
});